import { useSEO } from '../../hooks/useSEO';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import ProcessSection from './components/ProcessSection';
import ClientsSection from './components/ClientsSection';
import ContactSection from './components/ContactSection';

const HomePage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://bamme-media.de';

  useSEO({
    title: 'Bamme-Media Wernigerode | Webdesign, Foto-Video',
    description: 'Bamme-Media ist Ihre professionelle Digitalagentur in Wernigerode. Webdesign, Online Marketing, Social Media, Branding, Foto & Video - alles aus einer Hand. Jetzt kostenlose Beratung vereinbaren!',
    keywords: 'Bamme-Media, Wernigerode, Webdesign, Online Marketing, Social Media Marketing, Branding, Fotografie, Videografie, Digitalagentur, Website erstellen',
    canonical: `${siteUrl}/`,
    robots: 'index, follow',
    ogTitle: 'Bamme-Media Wernigerode | Professionelle Digitalagentur',
    ogDescription: 'Bamme-Media ist Ihre professionelle Digitalagentur in Wernigerode. Webdesign, Online Marketing, Social Media, Branding, Foto & Video - alles aus einer Hand.',
    ogImage: 'https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/a4f7c108bb0804aae360b11fcab28d64.png',
    ogImageWidth: '1200',
    ogImageHeight: '630',
    ogImageAlt: 'Bamme-Media - Professionelle Digitalagentur in Wernigerode',
    twitterTitle: 'Bamme-Media Wernigerode | Professionelle Digitalagentur',
    twitterDescription: 'Bamme-Media ist Ihre professionelle Digitalagentur in Wernigerode. Webdesign, Online Marketing, Social Media, Branding, Foto & Video - alles aus einer Hand.',
    twitterImage: 'https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/a4f7c108bb0804aae360b11fcab28d64.png',
    twitterImageAlt: 'Bamme-Media - Professionelle Digitalagentur in Wernigerode',
    geoPosition: '51.8312,10.7865',
    geoRegion: 'DE-ST',
    geoPlacename: 'Wernigerode',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Bamme-Media",
      "description": "Professionelle Digitalagentur in Wernigerode für Webdesign, Online Marketing, Social Media, Branding, Foto & Video",
      "url": siteUrl,
      "logo": "https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/fa291c43a7c1ed26d5ebb74eb50592e0.png",
      "image": "https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/a4f7c108bb0804aae360b11fcab28d64.png",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Wernigerode",
        "postalCode": "38855",
        "addressRegion": "Sachsen-Anhalt",
        "addressCountry": "DE"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "51.8312",
        "longitude": "10.7865"
      },
      "areaServed": [
        {
          "@type": "Place",
          "name": "Wernigerode"
        },
        {
          "@type": "Place", 
          "name": "Harz"
        },
        {
          "@type": "Place",
          "name": "Sachsen-Anhalt"
        },
        {
          "@type": "Place",
          "name": "Deutschland"
        }
      ],
      "serviceType": [
        "Webdesign",
        "Online Marketing", 
        "Social Media Marketing",
        "Branding & Design",
        "Fotografie",
        "Videografie"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Digitale Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Webdesign & Entwicklung",
              "description": "Moderne, responsive Websites und Online-Shops"
            }
          },
          {
            "@type": "Offer", 
            "itemOffered": {
              "@type": "Service",
              "name": "Social Media Marketing",
              "description": "Professionelle Betreuung Ihrer Social Media Kanäle"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service", 
              "name": "Branding & Design",
              "description": "Corporate Identity und visuelle Markenentwicklung"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Foto & Videografie",
              "description": "Professionelle Foto- und Videoproduktion"
            }
          }
        ]
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "areaServed": "DE",
        "availableLanguage": "German"
      },
      "sameAs": [
        "https://www.instagram.com/bamme.media/",
        "https://www.facebook.com/bamme.media/"
      ]
    }
  });

  return (
    <div>
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <ProcessSection />
      <ClientsSection />
      <ContactSection />
    </div>
  );
};

export default HomePage;
